/**
 * apps/web :: pages :: BlogPage
 *
 * Placeholder learner-portal surface for the in-app Blog (ROADS nav
 * restructure). Renders inside `<LearnerPortalShell>` like the other
 * informational learner pages. No backend calls yet — the editorial
 * content pipeline lands in a later ticket.
 */
import { useTranslation } from "react-i18next";

import LearnerPortalShell from "@/components/learner/LearnerPortalShell";

export default function BlogPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <LearnerPortalShell pageTitle={t("blog.title")}>
      <section className="mx-auto w-full max-w-3xl px-md pt-xl pb-xl sm:px-lg sm:pt-2xl sm:pb-2xl">
        <h1
          data-testid="blog-heading"
          className="font-display text-2xl font-bold text-brand-primary sm:text-3xl"
        >
          {t("blog.title")}
        </h1>
        <p className="mt-md text-neutral-700 sm:text-lg">{t("blog.body")}</p>
      </section>
    </LearnerPortalShell>
  );
}
